/**
 * Discussion Functionality for Private Area Post Comments
 *
 * @package LifterLMS_Private_Areas/Scripts
 *
 * @since 1.0.0
 * @version 1.0.0
 */

( function( $ ) {

	var $list     = $( '.llms-pa-discussion-list' ),
		$comments = $list.find( '.comment' );

	/**
	 * Handle AJAX Form Submission for comment form submissions
	 *
	 * @param    obj    e    JS event object
	 * @return   void
	 * @since    1.0.0
	 * @version  1.0.0
	 */
	$( '#llms_pa_leave_comment' ).on( 'click', function( e ) {
		e.preventDefault();

		var $form        = $( '#llms-pa-post-discussion-form' ),
			comment_text = $form.find( '#llms_pa_post_comment' ).val(),
			parent_id    = $( 'input[name="llms_pa_comment_parent_id"]' ).val(),
			nonce        = $( '#_pa_discussion_nonce' ).val(),
			pa_post_id   = $( 'input[name="llms_pa_post_id"]' ).val();

		if ( ! comment_text ) {
			return;
		}

		LLMS.Ajax.call( {
			data: {
				action: 'llms_pa_comment_add',
				comment: comment_text,
				nonce: nonce,
				parent_id: parent_id,
				pa_post_id: pa_post_id,
			},
			beforeSend: function() {

				LLMS.Spinner.start( $form );
				$form.find( '.error' ).remove();

			},
			success: function( r ) {

				if ( ! r.success ) {
					LLMS.Spinner.stop( $form );
					$form.prepend( '<p class="error">' + r.message + '</p>' );
				} else if ( r.data && r.data.redirect ) {
					window.location.href = r.data.redirect;
					window.location.reload();
				}

			}

		} );

	} );

	if ( $comments.length ) {

		/**
		 * Adds a "cancel" button when a replying to a comment
		 *
		 * @param    obj   $form  discussion form DOM element selector
		 * @since    1.0.0
		 * @version  1.0.0
		 */
		function add_cancel( $form ) {

			$cancel = $( '<a class="llms-pa-comment-reply-cancel" href="#">' + LLMS.l10n.translate( 'Cancel' ) + '</a>' );

			$form.find( '.llms-form-field.type-submit' ).append( $cancel );

			$cancel.on( 'click', function( e ) {
				e.preventDefault();
				$form.find( 'input[name="llms_pa_comment_parent_id"]' ).val( '0' );
				$( '#llms-pa-post-discussion-form-wrap' ).append( $form );
				$( this ).remove();
			} );

		}

		/**
		 * Moves the discussion form within a parent element (for replying to comments)
		 *
		 * @param    obl  $parent  DOM element selector of the element to append the form to
		 * @return   void
		 * @since    1.0.0
		 * @version  1.0.0
		 */
		function move_form( $parent ) {

			var $form     = $( '#llms-pa-post-discussion-form' ),
				parent_id = $parent.attr( 'id' ).replace( 'comment-', '' );

			if ( ! $form.find( '.llms-pa-comment-reply-cancel' ).length ) {
				add_cancel( $form );
			}

			$form.find( 'input[name="llms_pa_comment_parent_id"]' ).val( parent_id );

			$parent.find( '.comment-body' ).first().append( $form );

		}

		/**
		 * Makes an AJAX call to toggle comment status for a given comment
		 *
		 * @param    obj         $comment  DOM element for the comment
		 * @param    {Function}  cb        callback function
		 * @return   void
		 * @since    1.0.0
		 * @version  1.0.0
		 */
		function toggle_comment_status( $comment, cb ) {

			var $body = $comment.find( '.comment-body' ).first();

			LLMS.Ajax.call( {
				data: {
					action: 'llms_pa_comment_toggle_status',
					comment: $comment.attr( 'data-comment-id' ),
				},
				beforeSend: function() {
					LLMS.Spinner.start( $body );
				},
				success: function( r ) {

					if ( ! r.success ) {
						if ( r.message ) {
							alert( r.message );
						} else {
							LLMS.l10n.translate( 'Unable to save comment status. Please try again.' );
						}
					}

					LLMS.Spinner.stop( $body );
					cb( r );

				}

			} );

		}

		/**
		 * Binds the "Reply" and "Mark Read" links for all comments
		 *
		 * @return   void
		 * @since    1.0.0
		 * @version  1.0.0
		 */
		$comments.each( function() {

			var $comment = $( this ),
				$reply   = $comment.find( '.llms-pa-comment-reply' ).first(),
				$read    = $comment.find( '> .comment-body .llms-pa-comment-toggle-read' ).first();

			$reply.on( 'click', function( e ) {
				e.preventDefault();
				move_form( $comment );
			} );

			$read.on( 'click', function( e ) {
				e.preventDefault();
				toggle_comment_status( $comment, function( r ) {
					if ( r.success && r.data && r.data.status ) {
						$comment.removeClass( 'llms-pa-unread llmsa-pa-read' ).addClass( 'llms-pa-' + r.data.status );
						$read.attr( 'data-current-status', r.data.status );
					}
				} );
			} );

		} );

	}

} )( jQuery );
